








































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { AccountEquipmentLookup } from '@/models/admin/AccountEquipmentLookup';

import exportService from '@/services/ExportService';
import localStorageService from '@/services/LocalStorageService';
import equipmentTypeService from '@/services/EquipmentTypeService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      loading: false,
      editing: false,
      displayManageEquipmentTypesPopup: false,
      snackbar: false,
      snackbarText: '',
      term: '',
    };
  },
  created() {
    this.fetch();
    this.$store.commit('equipmentTypes/setSelectedAccountId', this.client.id);
  },
  methods: {
    backToPrevPage() {
      history.back();
    },
    onClear() {
      this.term = '';
      this.applyFilters();
    },
    fetch() {
      this.loading = true;
      const client = localStorageService.get('selected-afs-client');
      equipmentTypeService
        .getAllByAccount(client.id)
        .then((x: AccountEquipmentLookup[]) => {
          this.$store.commit('equipmentTypes/setAccountEquipmentTypes', x);

          this.applyFilters();
          this.loading = false;
        });

      equipmentTypeService.getAllEquipments().then((x) => {
        this.$store.commit(
          'equipmentTypes/setAllAvailable',
          x.map((item) => ({
            ...item,
            accountId: client.id,
          }))
        );
      });
    },
    applyFilters() {
      let items = this.all;

      if (this.term) {
        items = items.filter((x) =>
          x.description.toLowerCase().includes(this.term.toLowerCase())
        );
      }

      this.$store.commit('equipmentTypes/setFilteredEquipmentTypes', items);
      this.$store.commit(
        'equipmentTypes/setPage',
        items.slice(0, this.pageSize)
      );
      this.currentPage = 1;
    },
    clearFilters() {
      this.term = '';
      this.applyFilters();
    },
    equipmentAdded() {
      this.snackbarText = 'Equipment added.';
      this.snackbar = true;

      this.clearFilters();
    },
    equipmentRemoved() {
      this.snackbarText = 'Equipment removed.';
      this.snackbar = true;

      this.clearFilters();
    },
    resetFilter() {
      this.term = '';
      this.applyFilters();
    },
    csvExport() {
      const client = localStorageService.get('selected-afs-client');
      exportService.csvDownload(
        this.all,
        `${client?.company}’s Equipment Types`
      );
    },
    pageChange(newPage) {
      let page = this.all.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('equipmentTypes/setPage', page);
    },
    openManageEquipmentTypesPopup() {
      this.displayManageEquipmentTypesPopup = true;
    },
  },
  computed: {
    ...mapGetters('equipmentTypes', ['all', 'page', 'filteredEquipmentTypes']),
    pageHeader() {
      return `${this.client?.company}’s Equipment Requests`;
    },
    client() {
      return localStorageService.get('selected-afs-client');
    },
    pagingLength() {
      return Math.ceil(this.filteredEquipmentTypes.length / this.pageSize);
    },
    backToLbl() {
      return document.referrer?.includes('/dashboard')
        ? 'Back to Dashboard'
        : 'Back to Clients';
    },
  },
  watch: {
    all() {
      this.applyFilters();
    },
  },
});
